import {Link} from 'react-router-dom';
import {ArrowUpRight,MapPin,Home,Clock} from 'lucide-react';
import type {Job} from '../domain/types';
import {formatDate} from '../domain/policies';
import '../styles/featured-orders.css';
/** Three highlighted current orders, always above the job list. Banner = real photo + order title bar (HTML text, translatable). */
export function FeaturedOrders({jobs}:{jobs:Job[]}){
 const list=jobs.filter(j=>j.featured).sort((a,b)=>(a.featuredOrder||9)-(b.featuredOrder||9));
 if(!list.length)return null;
 return <section className={'container fo fo-n'+list.length} aria-labelledby="fo-title">
  <header className="fo-head"><span className="fo-kicker"><i aria-hidden="true"/>ĐANG TUYỂN · NỔI BẬT</span><h2 id="fo-title">Đơn hàng nổi bật</h2></header>
  <div className="fo-grid">{list.map((j,n)=>{const f=j.featuredImage;return <Link key={j.id} to={'/co-hoi/'+j.id} className={'fo-card fo-'+(n+1)}>
   <span className="fo-photo"><picture>{f&&<source media="(max-width:640px)" srcSet={f.mobile}/>}<img src={f?f.desktop:j.image} alt={f?.alt||''} loading={n===0?'eager':'lazy'} decoding="async"/></picture><span className="fo-badge">Đang tuyển</span></span>
   <span className="fo-bar">
    <strong>{j.title}</strong>
    <span className="fo-tags"><span><MapPin size={13} aria-hidden="true"/>{j.country}</span><span><Clock size={13} aria-hidden="true"/>Hợp đồng 2 năm</span><span><Home size={13} aria-hidden="true"/>Chỗ ở miễn phí</span></span>
    <span className="fo-foot">{j.featuredIncome&&<span className="fo-income"><small>Thu nhập dự kiến (gồm làm thêm)</small><b>{j.featuredIncome}</b></span>}<span className="fo-cta">Xem đơn hàng<ArrowUpRight size={16} aria-hidden="true"/></span></span>
    {f?.credit&&<small className="fo-credit">Ảnh minh họa: {f.credit}</small>}
    {j.datePublished&&<time dateTime={j.datePublished}>Đăng {formatDate(j.datePublished)}</time>}
   </span>
  </Link>})}</div>
 </section>;
}
